"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyReportInfoSyncItem = exports.StudyReportInfo = exports.StudyReportInfoStatus = exports.StudyReportInfoType = void 0;
var StudyReportInfoType;
(function (StudyReportInfoType) {
    StudyReportInfoType["Initial"] = "INITIAL";
    StudyReportInfoType["FollowUp"] = "FOLLOW-UP";
})(StudyReportInfoType = exports.StudyReportInfoType || (exports.StudyReportInfoType = {}));
var StudyReportInfoStatus;
(function (StudyReportInfoStatus) {
    StudyReportInfoStatus["Wait"] = "WAIT";
    StudyReportInfoStatus["Saved"] = "SAVED";
    StudyReportInfoStatus["Submitting"] = "SUBMITTING";
    StudyReportInfoStatus["Submitted"] = "SUBMITTED";
    StudyReportInfoStatus["Failed"] = "FAILED";
})(StudyReportInfoStatus = exports.StudyReportInfoStatus || (exports.StudyReportInfoStatus = {}));
class StudyReportInfo {
}
exports.StudyReportInfo = StudyReportInfo;
class StudyReportInfoSyncItem {
}
exports.StudyReportInfoSyncItem = StudyReportInfoSyncItem;
//# sourceMappingURL=studyReportInfo.js.map